import { useTranslation } from 'react-i18next';
import { Modal } from '@/shared/ui/components/basic/Modal';
import { SubscriptionHistoryCard } from '../SubscriptionHistoryCard';

interface Props {
  agencyId: string;
  opened: boolean;
  onClose: () => void;
}

/**
 * The full, paginated invoice history with its NF-e downloads.
 *
 * @param props - Component props.
 * @returns The modal.
 */
export function AllInvoicesModal({ agencyId, opened, onClose }: Props) {
  const { t } = useTranslation('features/pricing');

  return (
    <Modal opened={opened} onClose={onClose} size="3xl" title={t('subscription.history.title')}>
      <div data-testid="all-invoices-modal">
        {opened && <SubscriptionHistoryCard agencyId={agencyId} />}
      </div>
    </Modal>
  );
}
